import script from "./ReportExpiringView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportExpiringView.vue?vue&type=script&setup=true&lang=js"

import "./ReportExpiringView.vue?vue&type=style&index=0&id=65b1b391&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b1b391"]])

export default __exports__